import SignalsNewComponent from "../signalsNewComponent";
import React, {useEffect, useRef, useState} from "react";
import * as SignalsApi from "../../../api/signals";
import {toast} from "react-toastify";
import toastOptions from "../../../data/ToastOptions";
import {getAiProfitAlarmData, getAiSpottersAlarmData} from "../../../api/signals";
import {copyToClipboard} from "../../GlobalFunctions";

let timeout;

const AiSpotters = ({showModal, refetch}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [signals, setSignals] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const observerRef = useRef(null);

    useEffect(() => {
        getSignalsDataFn(1)
        return () => {
            clearTimeout(timeout)
        }
    }, [])

    useEffect(() => {
        if (refetch) {
            getSignalsDataFn(1)
        }
    }, [refetch])

    const getSignalsDataFn = (pageValue) => {
        setPage(pageValue)
        setIsLoading(true)
        timeout = setTimeout(() => {
            SignalsApi.getAiSpottersAlarmData({limit: 20, page: pageValue})
                .then(response => {
                    setHasMore(response.data.has_more)
                    if (pageValue === 1) {
                        setSignals(response.data.data)
                    } else {
                        setSignals([...signals, ...response.data.data])
                    }
                    setIsLoading(false)
                })
                .catch((err) => {
                    setIsLoading(false)
                    toast.error('Something went wrong! Please try again', {...toastOptions, toastId: 33})
                })
        }, 1000)
    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isLoading && hasMore) {
                    getSignalsDataFn(page + 1);
                }
            },
            { root: null, rootMargin: "0px", threshold: 1.0 }
        );
        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [isLoading, page]);

    const copyAddress = (value) => {
        copyToClipboard(value)
        // navigator.clipboard.writeText(value)
        // toast.success('Token Address Copied.', {...toastOptions, toastId: 19});
    }

    const refreshSignalsFn = () => {
        setSignals([])
        setHasMore(true);
        getSignalsDataFn(1);
    }

    return (
        <div className="signal-imageContainer">
            {signals && signals.length > 0 && signals?.map((item, index) => {
                return <SignalsNewComponent isSpotters={true} key={index.toString()} item={item} index={index} showModal={showModal} copyAddress={copyAddress} />
            })}
            {!isLoading && signals && signals.length === 0 && (
                <div className="mt30 center column">
                    <p className="text-white fs14">Nothing To Show</p>
                    <svg
                        className="mt10"
                        width="25"
                        height="25"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="12" cy="12" r="10" stroke="#FFFFFF" strokeWidth="1" fill="none" />
                        <circle cx="8" cy="9" r="1" fill="#FFFFFF" />
                        <circle cx="16" cy="9" r="1" fill="#FFFFFF" />
                        <path
                            d="M8 16 Q12 12 16 16"
                            stroke="#FFFFFF"
                            strokeWidth="1"
                            fill="none"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
            )}
            {hasMore && <div ref={observerRef} className="center mt30">
                <div className="loader"></div>
            </div>}
        </div>
    )
}

export default AiSpotters;
